// extracted by mini-css-extract-plugin
export default {"buttonContainer":"downloadTor_buttonContainer__hD1og","special":"downloadTor_special__-ko9f","btn":"downloadTor_btn__ZiBX9"};